<div class="fix-left-section-container">
  <div class="share-section mb-4">
    <div class="share-text mb-2">شارك المقال على</div>
    <div class="social-icons d-flex justify-content-end gap-2">
      <a href="#" class="social-icon">
        <i class="fa-brands fa-twitter"></i>
      </a>
      <a href="#" class="social-icon">
        <i class="fa-brands fa-facebook-f"></i>
      </a>
    </div>
  </div>

  <div class="watch-also-wrapper position-relative">
    <div class="green-backdrop"></div>
    <div class="gray-content-card">
      <h4 class="section-title mb-4">شاهد ايضا</h4>
      <ul class="custom-list p-0 m-0 list-unstyled">
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/goahead'" class="text-decoration-none text-dark fs-6 me-2">انطلق</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/investment-systems'" class="text-decoration-none text-dark fs-6 me-2">الأنظمة
            الاستثمارية</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/investmentzones'" class="text-decoration-none text-dark fs-6 me-2">المناطق الاستثمارية</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/indoorinvestments'" class="text-decoration-none text-dark fs-6 me-2">الإستثمار الداخلي</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/freezones'" class="text-decoration-none text-dark fs-6 me-2">المناطق الحرة</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/business-rules'" class="text-decoration-none text-dark fs-6 me-2">الحقائق التجارية</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/regulations-and-rules'" class="text-decoration-none text-dark fs-6 me-2">القوانين
            واللوائح</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/RulesInvestmentsAndBusinessComponent'"
            class="text-decoration-none text-dark fs-6 me-2">قوانين الاستثمار والأعمال</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/OrganizeRulesComponent'" class="text-decoration-none text-dark fs-6 me-2">قوانين التنظيم
            والتجارة</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/MoneyRulesComponent'" class="text-decoration-none text-dark fs-6 me-2">القوانين المالية</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/investor-guide'" class="text-decoration-none text-dark fs-6 me-2">دليل المستثمر</a>
        </li>
        <li class="mb-3 d-flex align-items-center justify-content-end">
          <a [routerLink]="'/suggested-sites'" class="text-decoration-none text-dark fs-6 me-2">مواقع مقترحة</a>
        </li>
      </ul>
    </div>
  </div>
</div>